import $ from 'jquery';
import {sprintf} from "Core/helpers/TemplateHelper";
import socialLinkToNameMap from "Core/entities/socialLinkToNameMap";
import {handlerVkShareBtn} from "../../sharing/vk-share-btn-handler";

export const handleSocialSection = () => {
    const container = $('.material-content-socials__buttons');
    const elementTemplate = `
        <div class='material-content-socials__button material-content-socials__button--%s'>
            <a href='%s' target='_blank' rel='noopener'></a>
        </div>
    `.trim();

    container.html('');

    for (const [link, name] of Object.entries(socialLinkToNameMap)) {
        container.append(sprintf(elementTemplate, name, link));

        handlerVkShareBtn();
    }
};
